import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { fileType } from 'types';
import termOptions from 'constants/termOptions';
import HeaderOptions from 'components/HeaderOptions';
import Search from 'components/Search';
import Button from 'components/Button';
import DropDownMenu from './components/DropDownMenu';

import './style.scss';

const FilesAndFoldersHeader = ({
  modelName,
  sidebarIsOpen,
  searchTerm,
  items,
  getItems,
  onOpenModal,
  addNewFile,
  exportAll,
  deleteAll,
  showMenu = true,
}) => {
  const termOption = termOptions.flow;

  return (
    <HeaderOptions
      bottomLeftOptions={<span styleName="root-item">Root /</span>}
      modelName={modelName}
      topRightOptions={
        <React.Fragment>
          <Search
            getItems={getItems}
            itemsCount={items.length}
            placeholder={termOption.search}
            searchTerm={searchTerm}
          />

          <Button
            isSmall
            data-test="upload-files-button"
            styleName={cn({ 'has-sidebar': sidebarIsOpen })}
            type="button"
            onClick={onOpenModal}
          >
            <i className={termOptions.flow.buttonClassName} />
            <span>{termOption.create}</span>
          </Button>

          {showMenu && (
            <DropDownMenu
              addNewFile={modelName === 'flow' ? undefined : addNewFile}
              deleteAll={deleteAll}
              exportAll={exportAll}
              items={items}
            />
          )}
        </React.Fragment>
      }
    />
  );
};

FilesAndFoldersHeader.propTypes = {
  addNewFile: PropTypes.func,
  deleteAll: PropTypes.func,
  exportAll: PropTypes.func,
  getItems: PropTypes.func,
  items: PropTypes.arrayOf(fileType),
  modelName: PropTypes.string,
  searchTerm: PropTypes.string,
  showMenu: PropTypes.bool,
  sidebarIsOpen: PropTypes.bool,
  onOpenModal: PropTypes.func,
};

export default FilesAndFoldersHeader;
